import * as React from "react";
import { connect } from "react-redux";
import { actions as nameActions } from "src/actions/name.actions";
import { actions } from "src/actions/main.actions";
import { actions as homeActions } from "src/actions/home.actions";
import Panel from "../../core/ui/panel";
import Grid, { Col } from "../../core/ui/grid";
import FormInput from "src/core/ui/input";
import Button from "src/core/ui/button";
import Checkbox from "../../core/ui/checkbox";
import IdentityService from "../../services/identity.service";
import { resolve } from "inversify-react";
import ToastService from "../../services/toast.service";
import {ChangePasswordRequest, PaymentService, UserService} from "../../services/openapi/generated";
import { IApplicationState, UserInformation } from "../../typings";

interface IAccountSettingsProps {
    idenntity: Partial<UserInformation>;
}

type AccountSettingsProps = IAccountSettingsProps & typeof actions & typeof homeActions;
interface IAccountSettingsState {
    currentPwd: string;
    password: string;
    retypePassword: string;
    passError?: string[];
    newPassError?: string[];
}

class AccountSettings extends React.Component<AccountSettingsProps, IAccountSettingsState> {
    @resolve
    public identity: IdentityService;

    @resolve
    public toast: ToastService;

    constructor(props: any) {
        super(props);
        this.state = {
            password: "",
            retypePassword: "",
            currentPwd: "",
        };
    }

    public componentDidMount() {
        this.props.changeLocation("settings");
    }

    public changePassword = async () => {
        await PaymentService.paymentControllerGetCredits();
        if (this.state.password === this.state.retypePassword) {
            const changePasswordRequest: ChangePasswordRequest
                = {new_password: this.state.password, old_password: this.state.currentPwd};
            UserService.userControllerChangePassword(changePasswordRequest)
                .then((result) => {
                    this.setState({
                        currentPwd: "",
                        retypePassword: "",
                        password: "",
                        passError: [],
                        newPassError: [],
                    });

                    this.toast.showToast("Password changed", "You have a new password", "success");
                })
                .catch((error) => {
                    this.toast.showToast("Error", error.body.message, "error");

                    this.setState({
                        passError: error.old_password,
                        newPassError: error.new_password,
                    });
                });
        }
    };

    public render() {
        const headerSize = 38;

        return (
            <React.Fragment>
                <Grid centered className="blurry">
                    <Col size={85}>
                        <Panel>
                            <Grid centered>
                                <Col className="panel-title" size={headerSize}>
                                    <div className="panel-title-header">
                                        <h1 className="required"></h1>
                                        <h1 className="panel-header">Change Password</h1>
                                    </div>
                                </Col>
                                <Col className="flex-column" size={100 - headerSize}>
                                    <FormInput
                                        style="dark"
                                        type="password"
                                        value={this.state.currentPwd}
                                        errors={this.state.passError}
                                        label="Current pwd."
                                        onChange={(e) => this.setState({ currentPwd: e })}
                                    />
                                    <FormInput
                                        style="dark"
                                        type="password"
                                        value={this.state.password}
                                        errors={this.state.newPassError}
                                        label="New pwd."
                                        onChange={(e) => this.setState({ password: e })}
                                    />
                                    <FormInput
                                        style="dark"
                                        type="password"
                                        value={this.state.retypePassword}
                                        label="Retype new pwd."
                                        onChange={(e) => this.setState({ retypePassword: e })}
                                        errors={this.state.newPassError}
                                        extraValidation={(e) => ({
                                            valid: e == this.state.password,
                                            defaultMessage: "The passwords does not match",
                                        })}
                                        extraContent={[
                                            <Button
                                                onClick={this.changePassword}
                                                disabled={this.state.password != this.state.retypePassword || !this.state.currentPwd}
                                                className="huge-btn"
                                                presentation="light"
                                                as={<button />}
                                            >
                                                Update
                                            </Button>,
                                        ]}
                                    />
                                </Col>
                            </Grid>
                        </Panel>
                        <Panel>
                            <Grid centered>
                                <Col className="panel-title" size={headerSize}>
                                    <div className="panel-title-header">
                                        <h1 className="required"></h1>
                                        <h1 className="panel-header">Email notifications</h1>
                                    </div>
                                </Col>
                                <Col size={100 - headerSize}>
                                    <Checkbox
                                        style="dark"
                                        value={this.props.idenntity.company_and_news_updates}
                                        label="Company news and updates"
                                        onChange={(e) => this.identity.update({ company_and_news_updates: e }, true)}
                                    />
                                    <Checkbox
                                        style="dark"
                                        value={this.props.idenntity.emergency_notifications}
                                        label="Emergency notifications"
                                        onChange={(e) => this.identity.update({ emergency_notifications: e }, true)}
                                    />
                                    <Checkbox
                                        style="dark"
                                        value={this.props.idenntity.notifications_of_transfer}
                                        label="Notifications of transfers"
                                        onChange={(e) => this.identity.update({ notifications_of_transfer: e }, true)}
                                    />
                                    <Checkbox
                                        style="dark"
                                        value={this.props.idenntity.favorite_notifications}
                                        label="Favorite notifications"
                                        onChange={(e) => this.identity.update({ favorite_notifications: e }, true)}
                                    />
                                </Col>
                            </Grid>
                        </Panel>
                    </Col>
                </Grid>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state: IApplicationState, ownProps: AccountSettingsProps): AccountSettingsProps {
    return {
        ...ownProps,
        idenntity: { ...state.identity.userInfo } || {},
    };
}
export default connect(mapStateToProps, { ...actions, ...nameActions, ...homeActions })(AccountSettings);



// WEBPACK FOOTER //
// ./src/components/account/account-settings.tsx